import { FieldViewModel } from "../../field/field-layout-view-model.model";
import { IStepRequest } from "./job-request.model";

export class CreateProductionWithheldExcelLogRequest implements IStepRequest {
	stepFunctionType = 'create-production-withheld-log' as const;
	stepParams: { productionJobId: string,  fields: FieldViewModel[] };
}
